import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import {Tabs, Tab} from "@material-ui/core";
import {Button} from "reactstrap";
import Types from "../../../../../constants/Types";
import API from "@beardeddevops/react.api";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Transfers',
		url: '/transfers',
		icon: 'random',
	},
];

class Transfer extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
		this.state.location = null;
		this.state.location_binary_id = null;
		this.state.toggleForm = false;
		this.state.in_network_transfer = null;
	}

	componentDidMount() {
		this.handleGetInnetwork().then();
	};

	updateData = (location, location_binary_id) => {
		this.setState({
			location: location,
			location_binary_id: location_binary_id
		})
	};

	printPdf = (form, sendEmail, hasNotes = false) => async () => {
		let model = new API.BuildClass(Types.Transactions_Collections_Forms._name, API.RequestType.CREATE);

		model.object.form = form;
		model.object.send_email = sendEmail;
		model.object.location = this.state.location;
		model.object.location_binary_id = this.state.location_binary_id;
		model.parent = this.props.match.params.id;
		hasNotes ? model.object.has_notes = true : model.object.has_notes = false;

		try {
			await model.submit(null, API.RequestType.CREATE);
		} catch (e) {
			return;
		}

		this.setState({tab: 'waybills'})

		this.refreshPage();
	};

	handleOpen = (el) => event => {
		this.setState({
			[el]: event.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorGen: null,
		});
	};

	handleToggleForm = () => {
		this.setState({toggleForm: !this.state.toggleForm})
	};

	generatedForm = () => {
		this.refreshPage();
		this.setState({tab: 'waybills'});
	};

	handleRepush = () => {
		let model = new API.BuildClass(Types.Acquisitions_Pendings._name, API.RequestType.UPDATE);
		model.object.pkey = this.props.match.params.id;
		try {
			model.submit(null, 'POST_REPUSH');
		} catch (e) {
			console.error('handleRepush error', e);
		}
	};

	handleGetInnetwork =  async() => {
		let model = new API.BuildClass(Types.Acquisitions_Pendings._name, API.RequestType.READ);
		model.object.pkey = this.props.match.params.id;
		try {
			let data = await model.submit(null, 'GET_INNETWORK');
			this.setState({ in_network_transfer: data.in_network });
		} catch (e) {
			console.error('handleGetInnetwork error', e);
			return false;
		}
	};

	render() {
		let {anchorGen} = this.state;
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/transfers/${this.props.id}`,
				icon: 'file-text-o',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					{this.props.rootState.hasNYP12Module &&
						<Button onClick={() => this.handleToggleForm()} size="sm" color="primary">
							<i className="fa fa-download"/>&nbsp;&nbsp;Generate New York P12 Form
						</Button>}
					{this.props.rootState.hasTransferShippingLabelModule &&
						<span>
								<Button
									size="sm"
									color="primary"
									aria-owns={anchorGen ? 'anchorGen' : null}
									aria-haspopup="true"
									onClick={this.handleOpen('anchorGen')}
								>
									<i className="fa fa-file-pdf-o"/>&nbsp;&nbsp;Generate Shipping Waybill
								</Button>
								<Menu
									id="anchorGen"
									anchorEl={anchorGen}
									open={Boolean(anchorGen)}
									onClose={this.handleClose}
									getContentAnchorEl={null}
									anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
									transformOrigin={{horizontal: 'left', vertical: 'top'}}
								>
									<MenuItem onClick={this.printPdf(20, false)}>
										<ListItemText inset primary="Generate Shipping Waybill"/>
									</MenuItem>
									<MenuItem onClick={this.printPdf(20, false, true)}>
										<ListItemText inset primary="Generate Shipping Waybill + Send My FFL"/>
									</MenuItem>
								</Menu>
						</span>}
					{this.state.in_network_transfer &&
						<Button onClick={this.handleRepush} size="sm" color="primary">
							<i className="fa fa-repeat"/>&nbsp;&nbsp;Repush In-Network Transfer
						</Button>
					}
				{this.props.rootState.hasTransferShippingLabelModule &&
					<Button onClick={this.printPdf(20, false)} size="sm" color="primary">
						<i className="fa fa-check-square-o"/>&nbsp;&nbsp;Generate Shipping Waybill
					</Button>
				}
				</Framework.Components.PageBar>


				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Transfer" value="details"/>
					<Tab label="Change Log" value="logs"/>
					{(this.props.rootState.hasTransferShippingLabelModule || this.props.rootState.hasNYP12Module) &&
						<Tab label={this.props.rootState.hasTransferShippingLabelModule && this.props.rootState.hasNYP12Module ? "Shipping Waybills & Forms" : (this.props.rootState.hasNYP12Module ? "Forms" : "Shipping Waybills")} value="waybills"/>
					}
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.Transfer
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						baseUrl={this.props.baseUrl}
						scannedCode={this.props.scannedCode}
						updateName={this.updateName}
						updateData={this.updateData}
						toggleForm={this.state.toggleForm}
						generatedForm={this.generatedForm}
						userAccess={this.props.rootState.userAccess}
					/>
				</div>
				{this.state.tab === 'logs' &&
				<Collections.LogsTransfers
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				{this.state.tab === 'waybills' &&
				<Collections.Forms
					parent={this.props.match.params.id}
					forForm={Types.Transactions_Collections_Forms._name}
					url="/transactions/[PARENT]/collections_forms"
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					afterSave={this.generatedForm}
					reloadSelf={this.state.refresh}
				/>}
			</div>
		);
	}
}
export default Framework.Components.withRootState(Transfer);
